import { DemoNegotiationState } from '../../types/demoNegotiationTypes';

export const getUpdateDemoNegotiationResourcePath = (id: string) => {
  return `/customer/demo_negotiations/${id}`;
};

export type GetDemoNegotiationParams = {
  state?: DemoNegotiationState[];
};
